import { WidgetConfig } from './widgetTypes';
import { Dealer } from './dealerTypes';
import { DealerGroup } from './dealerGroupTypes';
import { FeedView } from './feedViewTypes';
import { TranslationRulesId, TranslationRules } from './translationRulesTypes';
import { LeadFormConfig } from './leadFormTypes';

export type WebsiteId = string;

export interface WebThemeOverrides {
  colorPrimaryDark: string | null;
  colorSuccessDark: string | null;
  colorErrorDark: string | null;
  colorInfoDark?: string | null;
  colorMessageDark?: string | null;
  fontFacePrimary: string | null;
}

export enum WebThemeTarget {
  PREVIEW = 'preview',
  PUBLIC = 'public',
}

export enum WebThemeMethod {
  NONE = 'none',
  OVERRIDE = 'override',
  CUSTOM = 'custom',
}

export interface WebTheme {
  method: WebThemeMethod;
  overrides: WebThemeOverrides | null;
  customTheme: string | null;
  fontFile: string | null;
  fontFileBold?: string | null;
  previewUrl: string | null;
  publicUrl: string | null;
  previewOverrides: WebThemeOverrides | null;
  previewCustomTheme: string | null;
  previewFontFile: string | null;
  previewFontFileBold?: string | null;
}

export type FlowConfigSection = {
  id: string;
  name?: string;
  required?: boolean;
};

export type PickupLocation = {
  address: string;
  id: string;
  zip: string;
  name: string;
};

export enum StandaloneProduct {
  CREDIT_APPLICATION = 'Credit Application',
}

export interface Website {
  id: WebsiteId;
  name: string;
  dealer_id?: string | null;
  dealergroup_id?: string | null;
  Dealer?: Dealer | null;
  DealerGroup?: DealerGroup | null;
  FeedView: FeedView;
  widgetConfig: WidgetConfig['config'];
  useDealerGroupLogo: boolean;
  createdAt?: string;
  updatedAt?: string;
  theme?: WebTheme | null;
  flow?: FlowConfigSection[];
  translationRulesId?: TranslationRulesId | null;
  TranslationRule?: TranslationRules | null;
  trackingId?: string | null;
  gtmTrackingId?: string | null;
  gaMeasurementIds?: string[] | null;
  ddcByoMenuLinks?: {
    enabled?: boolean;
  };
  customPickup?: {
    enabled?: boolean;
    locations?: PickupLocation[];
    default?: PickupLocation;
    forceLocationSelectFirst?: {
      enabled?: boolean;
    };
  };
  configs?: {
    leadForm?: LeadFormConfig;
    orbeeTracking?: {
      dealerDomain?: string | null;
      providerToken?: string | null;
    };
    standaloneProducts?: StandaloneProduct[];
    standalonePurchaseType?: boolean;
  };
}

export enum MessageType {
  ERROR = 'error',
  SUCCESS = 'success',
  INFO = 'info',
}

export type PageMessageProps = {
  headline?: string;
  message: string;
  type: MessageType;
};
